module.exports = __webpack_public_path__ + "img/bg.794e43b5.png";